export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11873.b60f2f0a.jpg";